/*
All design system components should be exported from this file so that we only
need to replace them in a single place whenever we need to switch themes or upgrade
the design system version with breaking changes that may affect props
*/
import Icons from './Icons'
import LayoutComponents from './Layout'
import TextfieldComponents from './TextField'
import Theme from './Theme'
import Typography from './Typography'

const {
  IconAppleColored,
  IconBackArrow,
  IconClose,
  IconFacebookColored,
  IconGlobe,
  IconGoogleColored,
  IconHide,
  IconLock,
  IconMail,
  IconShow,
  IconXCircle,
} = Icons
const { Box, Inline, Layout, Stack } = LayoutComponents
const { TextField, TextFieldButton } = TextfieldComponents
const { BabbelFonts, BodyText, Heading, Text, Title } = Typography
const { BabbelThemeProvider, useTheme } = Theme

export { default as Badge } from './Badge'
export { default as Button } from './Button'
export * from './colours'
export { default as Footer } from './Footer'
export { default as Icons } from './Icons'
export {
  BabbelFonts,
  BabbelThemeProvider,
  BodyText,
  Box,
  Heading,
  IconAppleColored,
  IconBackArrow,
  IconClose,
  IconFacebookColored,
  IconGlobe,
  IconGoogleColored,
  IconHide,
  IconLock,
  IconMail,
  IconShow,
  IconXCircle,
  Inline,
  Layout,
  Stack,
  Text,
  TextField,
  TextFieldButton,
  Title,
  useTheme,
}
export { default as LayoutComponents } from './Layout'

export { default as Link } from './Link'
export { default as NavBarWrapper } from './NavBar'
export { default as Spinner } from './Spinner'
export { default as TextfieldComponents } from './TextField'
export { default as Theme } from './Theme'
export { default as Typography } from './Typography'
